<template>
  <div>
    <el-dialog
      id="editDialog"
      :title="orderId ? '修改采购单' : '新增采购单'"
      :visible="true"
      @close="close(false)"
      width="1000px"
    >
      <el-form
        :model="headInfo"
        label-position="right"
        label-width="110px"
        ref="editOrderFormRef"
        :rules="{
          orderDate: this.$ruleUtil.simple({
            fieldName: '单据日期',
            handleType: '选择',
            required: true,
          }),
          payVoucherSysFileIdList: this.$ruleUtil.array(
            '付款凭证',
            '上传',
            orderConfig.payVoucherRequired ? 1 : 0,
            10
          ),
          payRemark: this.$ruleUtil.simple({
            fieldName: '付款备注',
            required: false,
            max: 200,
          }),
          paperOrderSysFileIdList: this.$ruleUtil.array(
            '纸质单据',
            '上传',
            orderConfig.paperOrderRequired ? 1 : 0,
            10
          ),
          totalQuantity: this.$ruleUtil.number(
            '所选商品数量',
            this.quantityMinLimit
          ),
        }"
        v-if="headInfo"
      >
        <el-form-item label="单号" v-if="headInfo.id">
          <span v-fmtype="headInfo.orderNo ? null : 'info'">{{
            headInfo.orderNo || "草稿"
          }}</span>
        </el-form-item>
        <el-form-item label="单据日期" prop="orderDate">
          <el-date-picker
            v-model="headInfo.orderDate"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择单据日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="所选商品" prop="totalQuantity">
          <div class="fm-flex">
            <p
              v-fmtype="'success'"
              v-if="headInfo.totalQuantity && headInfo.totalQuantity > 0"
            >
              {{ "共 " + headInfo.totalQuantity + " 件商品" }}
            </p>
            <span v-fmtype="'error'" v-else>未选择商品</span>
            <span>，总采购价：</span>
            <FmAmount :amount="headInfo.commodityRetailTotalAmount"></FmAmount>
            <el-button
              class="fm-ml-15"
              type="primary"
              plain
              size="mini"
              icon="el-icon-plus"
              @click="showSelectCommodityDialog"
              >选择商品</el-button
            >
          </div>
        </el-form-item>
        <el-table
          :data="itemList || []"
          stripe
          :row-key="
            (row) => {
              return row.itemNo + row.commoditySpecId;
            }
          "
          max-height="500px"
          style="width: 100%"
        >
          <el-table-column
            label="商品图片"
            width="100"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <CommodityImage
                size="60px"
                :commodity="scope.row.commodity"
                :commoditySpec="scope.row.commoditySpec"
              ></CommodityImage>
            </template>
          </el-table-column>
          <el-table-column
            prop="commodityName"
            label="商品信息"
            min-width="250"
            align="left"
            header-align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div style="line-height: 1.4em">
                <div style="font-size: 1.1em">
                  {{ scope.row.commodity.name }}
                </div>
                <div class="fm-mt-5">
                  {{ "分类：" + scope.row.commodity.commodityCategory.name }}
                </div>
                <div>{{ "单位：" + scope.row.commodity.unit }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="commoditySpec.specName"
            label="规格名称"
            min-width="180"
            align="left"
            header-align="center"
          >
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" placement="top-start">
                <div slot="content" style="max-width: 300px">
                  {{ scope.row.commoditySpec.specName }}
                </div>
                <span class="fm-line-3">{{
                  scope.row.commoditySpec.specName
                }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="retailPrice"
            label="规格采购价"
            width="180"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <el-input-number
                style="width: 170px"
                v-model="scope.row.retailPrice"
                size="small"
                :precision="2"
                :min="0"
                :step="1"
                @change="changeItemPrice(scope.$index, scope.row)"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column
            prop="itemQuantity"
            label="购买数量"
            width="150"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <FmNumberDigitBox
                :key="
                  'itemQuantityInputNumber' + scope.$index + itemQuantityKey
                "
                :value="scope.row.itemQuantity"
                size="small"
                :min="0"
                :max="
                  scope.row.commoditySpec &&
                  !scope.row.commoditySpec.inProduction
                    ? scope.row.commoditySpec.availableQuantity
                    : 2147483647
                "
                :step="1"
                @change="
                  (e) => {
                    changeItemQuantity(scope.$index, scope.row, e);
                  }
                "
              ></FmNumberDigitBox>
            </template>
          </el-table-column>
          <el-table-column
            prop="commodityRetailTotalAmount"
            label="总采购价"
            width="120"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <FmAmount
                :amount="scope.row.commodityRetailTotalAmount"
              ></FmAmount>
            </template>
          </el-table-column>
          <el-table-column
            prop="disCountAmount"
            label="折扣金额"
            width="120"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <FmAmount :amount="scope.row.disCountAmount"></FmAmount>
            </template>
          </el-table-column>
          <el-table-column
            prop="itemAmount"
            label="成交价"
            width="200"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <el-input-number
                style="width: 170px"
                v-model="scope.row.itemAmount"
                size="small"
                :precision="2"
                :min="0"
                :max="
                  typeof scope.row.commodityRetailTotalAmount == 'string'
                    ? Number(scope.row.commodityRetailTotalAmount)
                    : scope.row.commodityRetailTotalAmount
                "
                :step="1"
                @change="changeItemAmount(scope.$index, scope.row)"
              ></el-input-number>
            </template>
          </el-table-column>
        </el-table>
        <el-form-item label="优惠金额" prop="disCountAmount" class="fm-mt-10">
          <FmAmount
            style="line-height: unset"
            :amount="headInfo.disCountAmount"
          ></FmAmount>
        </el-form-item>
        <el-form-item label="商品采购成交价" prop="commodityRetailAmount">
          <el-input-number
            v-model="headInfo.commodityRetailAmount"
            size="small"
            :precision="2"
            :min="0"
            :max="maxCommodityRetailAmount"
            :step="1"
            style="width: 180px"
            @change="changeCommodityRetailAmount"
          ></el-input-number>
        </el-form-item>
        <el-form-item
          label="付款凭证"
          class="fm-mt-10"
          prop="payVoucherSysFileIdList"
        >
          <div
            class="fm-rela UploadImage"
            v-for="(file, index) in payVoucherFileList"
            :key="index"
          >
            <el-image
              :id="'payVoucherImage' + index"
              class="UploadImage"
              :src="file.url"
              :preview-src-list="payVoucherFileList.map((d) => d.url)"
              :initial-index="index"
              alt=""
            />
            <div
              class="UploadImageLoadingIcon fm-center"
              v-if="file.status == 'ready'"
            >
              <i
                class="UploadImageLoadingIcon-icon el-icon el-icon-loading"
              ></i>
            </div>
            <div class="UploadImageHandleIcon">
              <i
                @click="payVoucherFilePreview(index)"
                alt="预览图片"
                class="UploadImageHandleIcon-icon fm-center UploadImageHandleIcon-previewIcon el-icon el-icon-view"
              ></i>
              <i
                alt="删除图片"
                @click="payVoucherFileDelete(index, file)"
                class="UploadImageHandleIcon-icon fm-center UploadImageHandleIcon-deleteIcon el-icon el-icon-delete"
              ></i>
            </div>
          </div>
          <el-upload
            :action="$envConfig.VUE_APP_uploadPurchaseOrderPayVoucher + ''"
            :headers="{
              AuthorityToken: $storageUtil.getAuthorityToken(),
            }"
            :limit="10"
            multiple
            accept="image/*"
            :file-list="payVoucherFileList"
            :show-file-list="false"
            :on-change="payVoucherFileChange"
            :on-success="payVoucherFileSuccess"
            :on-exceed="() => this.$message.warning('最多上传10张图片')"
            v-if="payVoucherFileList.length < 10"
          >
            <div slot="default" class="fm-center UploadImage">
              <i class="el-icon-plus"></i>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="付款备注" prop="payRemark">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            maxlength="200"
            show-word-limit
            v-model="headInfo.payRemark"
            style="width: 400px"
            placeholder="请输入付款备注信息"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="纸质单据"
          class="fm-mt-10"
          prop="paperOrderSysFileIdList"
        >
          <div
            class="fm-rela UploadImage"
            v-for="(file, index) in paperOrderFileList"
            :key="index"
          >
            <el-image
              :id="'paperOrderImage' + index"
              class="UploadImage"
              :src="file.url"
              :preview-src-list="paperOrderFileList.map((d) => d.url)"
              :initial-index="index"
              alt=""
            />
            <div
              class="UploadImageLoadingIcon fm-center"
              v-if="file.status == 'ready'"
            >
              <i
                class="UploadImageLoadingIcon-icon el-icon el-icon-loading"
              ></i>
            </div>
            <div class="UploadImageHandleIcon">
              <i
                @click="paperOrderFilePreview(index)"
                alt="预览图片"
                class="UploadImageHandleIcon-icon fm-center UploadImageHandleIcon-previewIcon el-icon el-icon-view"
              ></i>
              <i
                alt="删除图片"
                @click="paperOrderFileDelete(index, file)"
                class="UploadImageHandleIcon-icon fm-center UploadImageHandleIcon-deleteIcon el-icon el-icon-delete"
              ></i>
            </div>
          </div>
          <el-upload
            :action="$envConfig.VUE_APP_uploadPurchaseOrderPaperOrder + ''"
            :headers="{
              AuthorityToken: $storageUtil.getAuthorityToken(),
            }"
            :limit="10"
            multiple
            accept="image/*"
            :file-list="paperOrderFileList"
            :show-file-list="false"
            :on-change="paperOrderFileChange"
            :on-success="paperOrderFileSuccess"
            :on-exceed="() => this.$message.warning('最多上传10张图片')"
            v-if="paperOrderFileList.length < 10"
          >
            <div slot="default" class="fm-center UploadImage">
              <i class="el-icon-plus"></i>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            maxlength="200"
            show-word-limit
            v-model="headInfo.remark"
            style="width: 400px"
            placeholder="请输入备注信息"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <fm-justify-view>
          <p slot="left">
            单据金额：
            <FmAmount
              bold
              style="line-height: unset"
              :amount="headInfo.orderAmount"
            ></FmAmount>
          </p>
          <div slot="right">
            <el-button @click="close(false)">取 消</el-button>
            <el-button type="primary" @click="edit(false)"> 保存 </el-button>
          </div>
        </fm-justify-view>
      </div>
    </el-dialog>
    <CommoditySelectDialog
      :show="commoditySelectDialogShow"
      from="PurchaseOrder"
      :selectList="itemList"
      @selectCommodity="selectCommodity"
      @close="commoditySelectDialogShow = false"
      v-if="commoditySelectDialogShow"
    ></CommoditySelectDialog>
  </div>
</template>

<script>
export default {
  name: "Rterpv2WebPurchaseOrderEditDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    orderId: {
      type: String,
      default: null,
    },
  },
  watch: {
    show: {
      handler(newVal) {
        if (newVal) {
          this.orderConfig = this.$options.data().orderConfig;
          this.itemQuantityKey = this.$options.data().itemQuantityKey;
          this.headInfo = this.$options.data().headInfo;
          this.itemList = this.$options.data().itemList;
          this.customer = this.$options.data().customer;
          this.commoditySelectDialogShow =
            this.$options.data().commoditySelectDialogShow;
          this.payVoucherFileList = this.$options.data().payVoucherFileList;
          this.paperOrderFileList = this.$options.data().paperOrderFileList;
          setTimeout(() => {
            this.initOrderData();
            this.getOrderConfig();
            this.quantityMinLimit = this.$jsTool.getTenantCommodityMinValue();
          }, 100);
        }
        this.$nextTick(() => {
          this.$refs.editOrderFormRef.clearValidate();
        });
      },
      immediate: true,
    },
    orderId: {
      handler(newVal) {
        if (newVal) {
          setTimeout(() => {
            this.getOrderInfo();
          }, 100);
        }
      },
      immediate: true,
    },
  },
  computed: {
    maxCommodityRetailAmount() {
      if (!this.itemList || this.itemList.length == 0) {
        return;
      }
      let amount = this.$jsTool.sum(
        this.itemList.map((d) => d.commodityRetailTotalAmount)
      );
      return Number(amount);
    },
  },
  data() {
    return {
      orderConfig: {
        editCustomer: false,
        payVoucherRequired: true,
        paperOrderRequired: true,
      },

      itemQuantityKey: "null",

      headInfo: {
        orderDate: null,
        payVoucherSysFileIdList: [],
        payRemark: "",
        paperOrderSysFileIdList: [],
        commodityRetailTotalAmount: "0.00",
        disCountAmount: "0.00",
        commodityRetailAmount: "0.00",
        orderAmount: "0.00",
        totalQuantity: 0,
        remark: "",
      },
      itemList: [],

      commoditySelectDialogShow: false,

      payVoucherFileList: [],
      paperOrderFileList: [],

      quantityMinLimit: 0.001,
    };
  },

  mounted() {},

  methods: {
    async initOrderData() {
      this.headInfo.orderDate = this.$moment(new Date()).format("yyyy-MM-DD");
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.clearValidate();
      });
      this.$forceUpdate();
    },
    async getOrderConfig() {
      let res = await this.$api.tenantPersonalConfig_findByCodeIn([
        "Order:PurchaseOrder:EditCustomer",
        "Order:PurchaseOrder:PaperOrderRequired",
        "Order:PurchaseOrder:PayVoucherRequired",
      ]);
      if (res && res.success) {
        let editCustomerIndex = res.data.findIndex(
          (d) => d.code == "Order:PurchaseOrder:EditCustomer"
        );
        if (
          editCustomerIndex > -1 &&
          res.data[editCustomerIndex].value == "true"
        ) {
          this.orderConfig.editCustomer = true;
        }
        let payVoucherIndex = res.data.findIndex(
          (d) => d.code == "Order:PurchaseOrder:PayVoucherRequired"
        );
        if (
          payVoucherIndex > -1 &&
          res.data[payVoucherIndex].value == "false"
        ) {
          this.orderConfig.payVoucherRequired = false;
        }
        let paperOrderIndex = res.data.findIndex(
          (d) => d.code == "Order:PurchaseOrder:PaperOrderRequired"
        );
        if (
          paperOrderIndex > -1 &&
          res.data[paperOrderIndex].value == "false"
        ) {
          this.orderConfig.paperOrderRequired = false;
        }
      }
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.clearValidate();
      });
    },

    // 选择商品相关
    showSelectCommodityDialog() {
      this.commoditySelectDialogShow = true;
    },
    selectCommodity(list) {
      list.forEach((item, index) => {
        item.itemNo = index + 1; // 索引从 0 开始，所以 itemNo 从 1 开始
      });
      this.itemList = list;
      let commodityRetailAmount = "0.00";
      if (list && list.length > 0) {
        commodityRetailAmount = this.$jsTool.sum(list.map((d) => d.itemAmount));
      }
      this.headInfo.commodityRetailAmount = commodityRetailAmount;
      this.headInfo.commodityRetailTotalAmount = this.$jsTool.sum(
        list.map((d) => d.commodityRetailTotalAmount)
      );
      this.headInfo.disCountAmount = this.$jsTool.sub(
        this.headInfo.commodityRetailTotalAmount,
        this.headInfo.commodityRetailAmount
      );
      this.headInfo.orderAmount = commodityRetailAmount;
      this.headInfo.totalQuantity = Number(
        this.$jsTool.sumQuantity(list.map((d) => d.itemQuantity))
      );
      this.commoditySelectDialogShow = false;
    },
    changeItemPrice(index, row) {
      let itemAmount = this.$jsTool.multi(row.retailPrice, row.itemQuantity);
      row = {
        ...row,
        commodityRetailTotalAmount: itemAmount,
        disCountAmount: 0,
        itemAmount: itemAmount,
      };
      this.$nextTick(() => {
        this.changeItemAfterHandle(index, row);
      });
    },
    changeItemQuantity(index, row, value) {
      if (value == 0) {
        this.$confirm("是否移除所选商品?", "操作提醒", {
          confirmButtonText: "移除",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false,
          closeOnPressEscape: false,
          closeOnHashChange: false,
        })
          .then(() => {
            this.itemList.splice(index, 1);
            this.$nextTick(() => {
              this.changeItemAfterHandle(index);
            });
          })
          .catch(() => {
            row.itemQuantity = 1;
            this.itemQuantityKey = Math.random();
          });
      } else {
        let itemAmount = this.$jsTool.multi(row.retailPrice, value);
        row = {
          ...row,
          itemQuantity: value,
          commodityRetailTotalAmount: itemAmount,
          disCountAmount: 0,
          itemAmount: itemAmount,
        };
        this.$nextTick(() => {
          this.changeItemAfterHandle(index, row);
        });
      }
    },
    changeItemAmount(index, row) {
      if (
        (row.itemAmount || Number(row.itemAmount) == 0) &&
        (row.commodityRetailTotalAmount ||
          Number(row.commodityRetailTotalAmount) == 0)
      ) {
        row.disCountAmount = this.$jsTool.sub(
          row.commodityRetailTotalAmount,
          row.itemAmount
        );
      } else {
        row.disCountAmount = "0.00";
      }
      this.changeItemAfterHandle(index, row);
    },
    changeItemAfterHandle(index, row) {
      if (!row) {
        this.selectCommodity(this.itemList);
        return;
      }
      if (row.commoditySpecId) {
        this.itemList.splice(index, 1, row);
        this.selectCommodity(this.itemList);
      }
    },

    // 付款凭证有关
    payVoucherFilePreview(index) {
      document.getElementById("payVoucherImage" + index).click();
    },
    payVoucherFileDelete(index, file) {
      this.payVoucherFileList.splice(index, 1);
      this.initPayVoucherSysFileIdList();
    },
    payVoucherFileChange(file, fileList) {
      if (file.status == "ready") {
        this.payVoucherFileList.push({
          ...file,
          url: file.url || URL.createObjectURL(file.raw),
          status: "ready",
        });
      }
      this.initPayVoucherSysFileIdList();
    },
    payVoucherFileSuccess(res, file, fileList) {
      let index = this.payVoucherFileList.findIndex((d) => d.uid == file.uid);
      if (res && res.success) {
        this.$message({
          message: "文件上传成功",
          type: "success",
        });
        this.payVoucherFileList.splice(index, 1, {
          ...this.payVoucherFileList[index],
          url: res.data.prefix + res.data.name,
          id: res.data.id,
          status: "success",
        });
      } else {
        this.$message({
          message: "文件上传失败",
          type: "error",
        });
        this.payVoucherFileList.splice(index, 1);
      }
      this.initPayVoucherSysFileIdList();
    },
    initPayVoucherSysFileIdList() {
      this.$nextTick(() => {
        this.headInfo.payVoucherSysFileIdList = this.payVoucherFileList
          .filter((d) => d.status == "success")
          .map((d) => d.id);
        this.$refs.editOrderFormRef.validateField("payVoucherSysFileIdList");
      });
    },

    // 纸质单据有关
    paperOrderFilePreview(index) {
      document.getElementById("paperOrderImage" + index).click();
    },
    paperOrderFileDelete(index, file) {
      this.paperOrderFileList.splice(index, 1);
      this.initPaperOrderSysFileIdList();
    },
    paperOrderFileChange(file, fileList) {
      if (file.status == "ready") {
        this.paperOrderFileList.push({
          ...file,
          url: file.url || URL.createObjectURL(file.raw),
          status: "ready",
        });
      }
      this.initPaperOrderSysFileIdList();
    },
    paperOrderFileSuccess(res, file, fileList) {
      let index = this.paperOrderFileList.findIndex((d) => d.uid == file.uid);
      if (res && res.success) {
        this.$message({
          message: "文件上传成功",
          type: "success",
        });
        this.paperOrderFileList.splice(index, 1, {
          ...this.paperOrderFileList[index],
          url: res.data.prefix + res.data.name,
          id: res.data.id,
          status: "success",
        });
      } else {
        this.$message({
          message: "文件上传失败",
          type: "error",
        });
        this.paperOrderFileList.splice(index, 1);
      }
      this.initPaperOrderSysFileIdList();
    },
    initPaperOrderSysFileIdList() {
      this.$nextTick(() => {
        this.headInfo.paperOrderSysFileIdList = this.paperOrderFileList
          .filter((d) => d.status && d.status == "success")
          .map((d) => d.id);
        this.$refs.editOrderFormRef.validateField("paperOrderSysFileIdList");
      });
    },

    // 单据金额
    changeCommodityRetailAmount() {
      this.headInfo = {
        ...this.headInfo,
        disCountAmount: this.$jsTool.sub(
          this.headInfo.commodityRetailTotalAmount,
          this.headInfo.commodityRetailAmount
        ),
      };
      // 单据优惠比例，需要扣除套装的固定优惠
      let disCountRadio = this.$jsTool.divis(
        this.headInfo.disCountAmount,
        this.maxCommodityRetailAmount,
        8
      );
      let disCountAmount = 0;
      this.itemList.forEach((item, index) => {
        if (index == this.itemList.length - 1) {
          disCountAmount = this.$jsTool.sub(
            this.headInfo.disCountAmount,
            this.$jsTool.sum(
              this.itemList
                .filter((d) => d.commoditySpecId != item.commoditySpecId)
                .map((d) => d.disCountAmount)
            )
          );
        } else {
          disCountAmount = this.$jsTool.multi(
            disCountRadio,
            item.commodityRetailTotalAmount
          );
        }
        this.itemList.splice(index, 1, {
          ...this.itemList[index],
          itemAmount: this.$jsTool.sub(
            item.commodityRetailTotalAmount,
            disCountAmount
          ),
          disCountAmount: disCountAmount,
        });
      });
      this.selectCommodity(this.itemList);
    },

    async getOrderInfo(args) {
      let res = await this.$api.purchaseOrder_findVoById(this.orderId, {
        showLoading: true,
        loadingParam: {
          target: "#editDialog > *",
          lock: true,
        },
        ...args,
      });
      if (res && res.success) {
        this.headInfo = {
          ...res.data.headVo,
          payVoucherSysFileIdList: res.data.headVo.payVoucherImageList.map(
            (d) => d.sysFile.id
          ),
          paperOrderSysFileIdList: res.data.headVo.paperOrderImageList.map(
            (d) => d.sysFile.id
          ),
          payRemark: res.data.headVo.payRemark || "",
        };
        this.customer = res.data.headVo.customer;
        this.itemList = res.data.itemList;
        this.payVoucherFileList = res.data.headVo.payVoucherImageList.map(
          (item) => {
            return {
              imageName: item.sysFile.name,
              id: item.sysFile.id,
              message: "已有图片",
              status: "success",
              thumb: item.sysFile.prefix + item.sysFile.name,
              type: "image",
              url: item.sysFile.prefix + item.sysFile.name,
            };
          }
        );
        this.paperOrderFileList = res.data.headVo.paperOrderImageList.map(
          (item) => {
            return {
              imageName: item.sysFile.name,
              id: item.sysFile.id,
              message: "已有图片",
              status: "success",
              thumb: item.sysFile.prefix + item.sysFile.name,
              type: "image",
              url: item.sysFile.prefix + item.sysFile.name,
            };
          }
        );
        this.$nextTick(() => {
          setTimeout(() => {
            this.$forceUpdate();
          }, 200);
        });
      }
    },

    edit() {
      if (
        this.payVoucherFileList &&
        this.payVoucherFileList.length > 0 &&
        this.payVoucherFileList.filter((d) => d.status == "success").length > 0
      ) {
        this.headInfo.payVoucherSysFileIdList = this.payVoucherFileList
          .filter((d) => d.status == "success")
          .map((d) => d.id);
      }
      if (
        this.paperOrderFileList &&
        this.paperOrderFileList.length > 0 &&
        this.paperOrderFileList.filter((d) => d.status == "success").length > 0
      ) {
        this.headInfo.paperOrderSysFileIdList = this.paperOrderFileList
          .filter((d) => d.status == "success")
          .map((d) => d.id);
      }
      this.$refs.editOrderFormRef.validate(async (valid) => {
        if (!valid) {
          return;
        }
        let requestRes = this.headInfo.id
          ? await this.$api.purchaseOrder_update(
              {
                headUpdatePojo: this.headInfo,
                itemAddNewPojoList: this.itemList,
              },
              {
                showLoading: true,
                loadingParam: {
                  target: "#editDialog > *",
                  lock: true,
                  text: "修改中...",
                },
              }
            )
          : await this.$api.purchaseOrder_addNew(
              {
                headAddNewPojo: this.headInfo,
                itemAddNewPojoList: this.itemList,
              },
              {
                showLoading: true,
                loadingParam: {
                  target: "#editDialog > *",
                  lock: true,
                  text: "修改中...",
                },
              }
            );
        if (requestRes && requestRes.success) {
          this.close(true);
        }
      });
    },

    close(flush) {
      this.$emit("close", flush);
    },
  },
};
</script>

<style lang="scss" scoped>
.UploadImage {
  float: left;
  width: 100px !important;
  height: 100px !important;
  margin-right: 10px;
  border: 1px dashed var(--fm-border-color);
  border-radius: 5px;
  background-color: var(--fm-border-extralight-color);
  overflow: hidden;
  cursor: pointer;

  &:hover {
    border: 1px dashed var(--fm-primary-color);
  }
}

.UploadImageLoadingIcon {
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.4);
  width: 100px;
  height: 100px;

  &-icon {
    color: white;
    font-size: 18px;
  }
}

.UploadImageHandleIcon {
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.4);
  opacity: 0;
  width: 100px;
  height: 100px;

  &:hover {
    opacity: 1;
  }

  &-icon {
    position: absolute;
    top: 0;
    width: 50px;
    height: 100px;
    color: white;
    font-size: 18px;
  }

  &-previewIcon {
    left: 0;
  }

  &-deleteIcon {
    left: 50px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/PurchaseOrderEditDialog.vue